import { InputOptions, ToolbarOptions } from "src/interfaces/toolBar.interface";
import { IconMapModel, IconHomeLocation, IconYourLocation, IconMap, IconRulerTool, IconMeasureRuler, IconEraser, IconEyeShow, IconEyeHide, IconTrash, IconTick, IconPointTool, IconPointMarket, IconLabelProperties, IconDataElement, IconFlyCamera, IconFastCamera, IconPlayCamera, IconPauseCamera, IconSlowCamera, IconDotFlyCamera, IconIssues, IconMeasureMultiRuler, IconLayerModel, IconClippingPlane, IconClippingZ, IconClippingX, IconClippingY, IconCursorClick } from "../icon";
import { createUUID, handleWindowResizeByElement, watchElement } from "../utils/utils";
import { ContextMenu } from "./contextMenu";
import { Coordinates } from "./mapDistance/coordinates";
// import { DataPropeties } from "./dataProperties";
import { FlyCamera } from "./flyCamera";
import { FlyLocation } from "./flyToLocation";
import { LabelPoint } from "./mapDistance/labelPoint";
import { MapWheater } from "./mapWeather";
import { MeasureCesium } from "./mapDistance/measureCesium";
import { TreeTileModel } from "./treeTileModel";
import { getMessage } from "../language";
import { Viewer } from "cesium";
import { IssuePoint } from "./issuePoint/issuePoint";
import { ClippingPlaneCesium } from "./clippingPlane";
import { DataPropeties } from "./newDataProperties";
import { LayerModelNew } from "./layerModelNew";
import { ToolbarMeasureHandler } from "./toolbar/toolbarMeasureHandler";
import { ToolbarPointHandler } from "./toolbar/toolbarPointHandler";
import { ToolbarClippingPlaneHandler } from "./toolbar/toolbarClippingPlaneHandler";
import { ToolbarFlyCameraHandler } from "./toolbar/toolbarFlyCameraHandler";
import { ToolbarIssuePointHandler } from "./toolbar/toolbarIssuePointHandler";

export enum MapToolType {
    MEASURE = 'measure',
    POINT = 'point',
    LABEL_POINT = 'labelPoint',
    CLIPPING_PLANE = 'clippingPlane',
    FLY_CAMERA = 'flyCamera',
    ISSUE_POINT = 'issuePoint'
}

export class CreateToolbar {
    public _containerIdView: string

    private _treeTileModel: TreeTileModel | undefined
    private _layerModel: LayerModelNew | undefined
    private _flyToLcation: FlyLocation | undefined;
    public _contextMenu: ContextMenu | undefined
    public _mapWeather: MapWheater | undefined;

    public _measure: MeasureCesium | undefined
    private _dataProperties: DataPropeties | undefined
    private _labelPoint: LabelPoint | undefined
    public _pointCesium: Coordinates | undefined
    public _flyCamera: FlyCamera | undefined
    public _clippingPlane: ClippingPlaneCesium | undefined
    issuePoint: IssuePoint | undefined
    // private  _treeViews: TreeViews | undefined
    public _espChoose = 5897 | 0

    public _activeBtnClippingPlane = false;
    public _isShowModalIssuePoint = false;

    private _measureHandler: ToolbarMeasureHandler;
    private _pointHandler: ToolbarPointHandler;
    private _clippingPlaneHandler: ToolbarClippingPlaneHandler;
    private _flyCameraHandler: ToolbarFlyCameraHandler;
    private _issuePointHandler: ToolbarIssuePointHandler;

    // Element ID Helper Getters
    public get _doneDimId(): string { return `done-dim-${this._containerIdView}`; }
    public get _donePointId(): string { return `done-point-${this._containerIdView}`; }
    public get _labelPropertiesId(): string { return `label-properties-${this._containerIdView}`; }
    public get _clippingPlaneDoneId(): string { return `clipping-plane-done-${this._containerIdView}`; }
    public get _doneFlyId(): string { return `done-fly-${this._containerIdView}`; }
    public get _issuePointId(): string { return `issue-point-${this._containerIdView}`; }

    constructor(containerId: string, viewer: Viewer, inputOption: InputOptions, options: ToolbarOptions = {}) {
        this._containerIdView = containerId
        // Mặc định là true cho tất cả các thành phần
        const defaultOptions: ToolbarOptions = {
            //Map model
            treeTileModel: true,
            layerModel: false,
            //location
            homeLocation: true,
            yourLocation: true,
            mapWeather: true,
            //None map
            isNoneMap: false,
            //Distance
            measure: true,
            point: true,
            labelPoint: true,
            //Data
            dataProperties: true,
            //Fly camera
            flyCamera: true,
            //TreeView
            treeViews: true,
            //clipping plane
            clippingPlane: false,
            //flytoVietNam
            flyToVietNam: true,
            //issuesPoint
            issuePoint: false

        };

        // Kết hợp các options truyền vào với giá trị mặc định
        const finalOptions: ToolbarOptions = { ...defaultOptions, ...options };

        this._treeTileModel = inputOption.treeTileModel
        this._flyToLcation = inputOption.flyToLcation
        this._contextMenu = inputOption.contextMenu
        this._dataProperties = inputOption.dataProperties
        this._labelPoint = inputOption.labelPoint
        this._pointCesium = inputOption.pointCesium
        this._espChoose = inputOption.espChoose || 5897
        this._flyCamera = inputOption.flyCamera
        this._mapWeather = inputOption.mapWeather
        this._layerModel = inputOption.treeLayerModel
        // treeViews = inputOption.treeViews
        // // Khởi tạo các thành phần tùy thuộc vào các options đã chọn

        // //Bản đồ
        // if (finalOptions.mapWeather) {
        //     mapWeather = new MapWheater(containerId, viewer, finalOptions.isNoneMap)

        // }
        if (finalOptions.isNoneMap) {
            this._contextMenu!.opacityClick = 1.0
        }
        //Dim
        if (finalOptions.measure) {
            this._measure = new MeasureCesium(containerId, viewer)
        }
        //Point
        if (finalOptions.point) {
            this._pointCesium = new Coordinates(containerId, viewer)
        }

        if (finalOptions.issuePoint) {
            this.issuePoint = new IssuePoint(containerId, viewer, this._contextMenu!)
        }
        if (finalOptions.clippingPlane) {
            this._clippingPlane = new ClippingPlaneCesium({ viewer, containerId, })
        }

        this._measureHandler = new ToolbarMeasureHandler(this);
        this._pointHandler = new ToolbarPointHandler(this);
        this._clippingPlaneHandler = new ToolbarClippingPlaneHandler(this);
        this._flyCameraHandler = new ToolbarFlyCameraHandler(this);
        this._issuePointHandler = new ToolbarIssuePointHandler(this);

        // #region  buttonConfig
        const buttonConfig = [
            //Model
            {
                id: `group-model-${containerId}`,
                className: 'container-tool-cesium',
                buttons: [
                    {
                        id: `map-model-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconMapModel(),
                        tooltip: getMessage("tool-tip-model"),
                        show: finalOptions.treeTileModel,
                        onClick: () => { this.mapModel(`map-model-${containerId}`) }
                    }, {
                        id: `layer-element-${containerId}`,
                        className: 'btn-tool-cesium padding-btn-tool-cesium',
                        icon: IconLayerModel(),
                        tooltip: getMessage("tool-tip-layer"),
                        show: finalOptions.layerModel,
                        onClick: () => { this.layerModel(`layer-element-${containerId}`) }
                    }
                ],
                show: true
            },
            //Location
            {
                id: `group-location-${containerId}`,
                className: 'container-tool-cesium',
                buttons: [
                    {
                        id: `home-location-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconHomeLocation(),
                        tooltip: getMessage("tool-tip-project-location"),
                        show: finalOptions.homeLocation,
                        onClick: () => { this._flyToLcation!.flyToHomeLocation() }
                    },
                    {
                        id: `your-location-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconYourLocation(),
                        tooltip: getMessage("tool-tip-your-location"),
                        show: finalOptions.yourLocation,
                        onClick: () => { this._flyToLcation!.flyToCurrentLocation() }
                    },
                    {
                        id: `map-weather-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconMap(),
                        tooltip: getMessage("tool-tip-map"),
                        show: finalOptions.mapWeather,
                        onClick: () => { this.ToolBarActionMapWeather(`map-weather-${containerId}`) }
                    }
                ],
                show: true
            },
            //distance
            {
                id: `group-distance-${containerId}`,
                className: 'container-tool-cesium',
                show: true,
                buttons: [
                    //Dim group
                    {
                        id: `dim-group-${containerId}`,
                        className: 'container-btn-tool-cesium',
                        show: finalOptions.measure,
                        tooltip: getMessage("tool-tip-measure"),
                        buttons: [
                            {
                                id: `ruler-tool-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure"),
                                icon: IconRulerTool(),
                                show: true,
                                onClick: () => { this.ToolBarActionDim(`ruler-tool-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `measure-ruler-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure-action"),
                                icon: IconMeasureRuler(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`measure-ruler-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `measure-multi-ruler-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure-multi-action"),
                                icon: IconMeasureMultiRuler(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`measure-multi-ruler-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `eraser-measure-ruler-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure-delete-pick"),
                                icon: IconEraser(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`eraser-measure-ruler-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `eye-show-dim-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure-visible"),
                                icon: IconEyeShow(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`eye-show-dim-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `eye-hide-dim-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure-hide"),
                                icon: IconEyeHide(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`eye-hide-dim-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `remove-all-dim-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-measure-delete-all"),
                                icon: IconTrash(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`remove-all-dim-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `done-dim-${containerId}`,
                                className: 'btn-tool-cesium done',
                                tooltip: '',
                                icon: IconTick(),
                                show: false,
                                onClick: () => { this.ToolBarActionDim(`done-dim-${containerId}`, `${containerId}`) }
                            }
                        ]
                    },
                    //Point group
                    {
                        id: `point-group-${containerId}`,
                        className: 'container-btn-tool-cesium',
                        show: finalOptions.point,
                        tooltip: 'Tọa độ điểm',
                        buttons: [
                            {
                                id: `point-tool-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-coordinates"),
                                icon: IconPointTool(),
                                show: true,
                                onClick: () => { this.ToolBarActionPoint(`point-tool-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `point-pick-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-coordinates-action"),
                                icon: IconPointMarket(),
                                show: false,
                                onClick: () => { this.ToolBarActionPoint(`point-pick-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `eraser-point-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-coordinates-delete-pick"),
                                icon: IconEraser(),
                                show: false,
                                onClick: () => { this.ToolBarActionPoint(`eraser-point-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `eye-hide-point-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-coordinates-hide"),
                                icon: IconEyeHide(),
                                show: false,
                                onClick: () => { this.ToolBarActionPoint(`eye-hide-point-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `eye-show-point-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-coordinates-visible"),
                                icon: IconEyeShow(),
                                show: false,
                                onClick: () => { this.ToolBarActionPoint(`eye-show-point-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `remove-all-point-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-coordinates-delete-all"),
                                icon: IconTrash(),
                                show: false,
                                onClick: () => { this.ToolBarActionPoint(`remove-all-point-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `done-point-${containerId}`,
                                className: 'btn-tool-cesium done',
                                tooltip: '',
                                icon: IconTick(),
                                show: false,
                                onClick: () => { this.ToolBarActionPoint(`done-point-${containerId}`, `${containerId}`) }
                            }
                        ]
                    },

                    //Label Point
                    {
                        id: `label-properties-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconLabelProperties(),
                        tooltip: getMessage("tool-tip-label-point"),
                        show: finalOptions.labelPoint,
                        onClick: () => { this.ToolBarActionLabelPropeties(`label-properties-${containerId}`) }
                    },
                ]
            },

            //Data
            {
                id: `group-data-${containerId}`,
                className: 'container-tool-cesium',
                buttons: [
                    {
                        id: `data-element-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconDataElement(),
                        tooltip: getMessage("tool-tip-data-properties"),
                        show: finalOptions.dataProperties,
                        onClick: () => { this.ToolBarActionDataElement(`data-element-${containerId}`) }
                    },



                ],
                show: true
            },
            //Fly
            {
                id: `group-camera-${containerId}`,
                className: 'container-tool-cesium',
                show: true,
                buttons: [
                    //Fly group
                    {
                        id: `group-fly-camera-${containerId}`,
                        className: 'container-btn-tool-cesium',
                        show: finalOptions.flyCamera,
                        tooltip: getMessage("tool-tip-camera-fly"),
                        buttons: [
                            {
                                id: `fly-camera-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-camera-fly"),
                                icon: IconFlyCamera(),
                                show: true,
                                onClick: () => { this.ToolBarActionFlyCamera(`fly-camera-${containerId}`) }
                            },
                            {
                                id: `fly-fast-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-camera-fly-fast"),
                                icon: IconFastCamera(),
                                show: false,
                                onClick: () => { this.ToolBarActionFlyCamera(`fly-fast-${containerId}`) }
                            },
                            {
                                id: `fly-play-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-camera-fly-start"),
                                icon: IconPlayCamera(),
                                show: false,
                                onClick: () => { this.ToolBarActionFlyCamera(`fly-play-${containerId}`) }
                            },
                            {
                                id: `fly-pause-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-camera-fly-pause"),
                                icon: IconPauseCamera(),
                                show: false,
                                onClick: () => { this.ToolBarActionFlyCamera(`fly-pause-${containerId}`) }
                            },
                            {
                                id: `fly-slow-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-camera-fly-slow"),
                                icon: IconSlowCamera(),
                                show: false,
                                onClick: () => { this.ToolBarActionFlyCamera(`fly-slow-${containerId}`) }
                            },
                            {
                                id: `fly-path-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-camera-fly-visbile-path"),
                                icon: IconDotFlyCamera(),
                                show: false,
                                onClick: () => { this.ToolBarActionFlyCamera(`fly-path-${containerId}`) }
                            },
                            {
                                id: `done-fly-${containerId}`,
                                className: 'btn-tool-cesium done',
                                tooltip: '',
                                icon: IconTick(),
                                show: false,
                                onClick: () => { this.ToolBarActionFlyCamera(`done-fly-${containerId}`) }
                            }
                        ]
                    },


                ]
            },

            //Clipping
            {
                id: `group-clipping-${containerId}`,
                className: 'container-tool-cesium',
                show: true,
                buttons: [
                    // Clipping Plane sub-group
                    {
                        id: `group-clipping-plane-${containerId}`,
                        className: 'container-btn-tool-cesium',
                        show: finalOptions.clippingPlane,
                        tooltip: "Cắt mô hình",
                        buttons: [
                            {
                                id: `clipping-plane-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-plane") || "Cắt mô hình",
                                icon: IconClippingPlane(),
                                show: true,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-z-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-z") || "Trục Đứng (Z)",
                                icon: IconClippingZ(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-z-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-x-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-x") || "Trục Ngang (X)",
                                icon: IconClippingX(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-x-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-y-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-y") || "Trục Ngang (Y)",
                                icon: IconClippingY(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-y-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-toggle-gizmo-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-toggle-gizmo") || "Ẩn/Hiện Gizmo",
                                icon: IconEyeShow(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-toggle-gizmo-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-lock-gizmo-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-lock-gizmo") || "Tương tác / Tạm dừng",
                                icon: IconCursorClick(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-lock-gizmo-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-delete-${containerId}`,
                                className: 'btn-tool-cesium',
                                tooltip: getMessage("tool-tip-clipping-delete") || "Xóa mặt cắt",
                                icon: IconTrash(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-delete-${containerId}`, `${containerId}`) }
                            },
                            {
                                id: `clipping-plane-done-${containerId}`,
                                className: 'btn-tool-cesium done',
                                tooltip: '',
                                icon: IconTick(),
                                show: false,
                                onClick: () => { this.ToolBarActionClippingPlane(`clipping-plane-done-${containerId}`, `${containerId}`) }
                            }
                        ]
                    }
                ]
            },

            //Markup
            {
                id: `group-note-${containerId}`,
                className: 'container-tool-cesium',
                buttons: [
                    {
                        id: `issue-point-${containerId}`,
                        className: 'btn-tool-cesium',
                        icon: IconIssues(),
                        tooltip: "Issues",
                        show: finalOptions.issuePoint,
                        onClick: () => { this.ToolBarActionIssuePoint(`issue-point-${containerId}`) }
                    },
                ],
                show: finalOptions.issuePoint
            },
        ];

        //#region checkOptionToolbar
        this.checkOptionToolbar(finalOptions, buttonConfig)

        // Tạo toolbar từ buttonConfig

        const container = document.getElementById(containerId);
        if (!container) {
            console.error(`Container with ID "${containerId}" not found`);
            return;
        }

        // Tìm phần tử con có class 'cesium-viewer' trong container
        const viewerElement = container.querySelector('.cesium-viewer');
        if (!viewerElement) {
            console.error(`Viewer element with class 'cesium-viewer' not found in container "${containerId}"`);
            return;
        }

        // Tạo toolbar chính
        const toolbar = document.createElement('div');
        toolbar.className = 'custom-toolbar-dpu';

        // Đệ quy để render từng group
        buttonConfig.forEach(group => {
            if (group.show) {
                const groupElement = this.createButtonElement(group); // Sử dụng hàm đệ quy để tạo group
                if (groupElement) {
                    toolbar.appendChild(groupElement);
                }
            }
        });

        // Thêm toolbar vào viewer
        viewerElement.appendChild(toolbar);

        buttonConfig.forEach(group => {
            if (group.buttons && Array.isArray(group.buttons)) {
                // Kiểm tra nếu tất cả các button bên trong có show: false
                const allButtonsHidden = group.buttons.every(button => button.show === false);

                if (group.buttons.length == 0 || allButtonsHidden) {
                    // Query DOM theo id của nhóm và đặt display: none
                    // showHideElementByID(group.id, false);
                    // Query DOM theo id của nhóm
                    const element = document.getElementById(group.id);
                    if (element) {
                        element.remove(); // Xóa phần tử khỏi DOM
                    }
                }
            }
        });


        //Theo dỗi thay đổi của màn hình
        if (container) {
            watchElement(container, ({ width, height }) => {
                this.handlePositionToolbar(width, height, container)

            })
            window.addEventListener('resize', () => {

                handleWindowResizeByElement(container, ({ width, height }) => {

                    this.handlePositionToolbar(width, height, container)

                })
            })
        }



    };


    //#region Check option Toolbar
    checkOptionToolbar = (finalOptions: ToolbarOptions, buttonConfig: any[]) => {
        Object.entries(finalOptions).forEach(([key, value]) => {
            if (key === 'treeTileModel' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`map-model-${this._containerIdView}`])
            } else if (key === 'homeLocation' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`home-location-${this._containerIdView}`])

            } else if (key === 'yourLocation' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`your-location-${this._containerIdView}`])

            } else if (key === 'mapWeather' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`map-weather-${this._containerIdView}`])

            } else if (key === 'measure' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`dim-group-${this._containerIdView}`])

            } else if (key === 'point' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`point-group-${this._containerIdView}`])

            } else if (key === 'labelPoint' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`label-properties-${this._containerIdView}`])

            } else if (key === 'dataProperties' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`data-element-${this._containerIdView}`])

            } else if (key === 'flyCamera' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`group-fly-camera-${this._containerIdView}`])

            } else if (key === 'clippingPlane' && !value) {
                this.removeButtonsConfigById(buttonConfig, [`group-clipping-plane-${this._containerIdView}`]);
                this.removeButtonsConfigById(buttonConfig, [`group-clipping-${this._containerIdView}`]);
            }
        });
    }
    //#region remove btn config by Id
    removeButtonsConfigById = (buttonConfig: any[], idsToRemove: string[]): any[] => {
        return buttonConfig
            .map(group => {
                // Loại bỏ các buttons có id trong danh sách idsToRemove
                if (group.buttons && Array.isArray(group.buttons)) {
                    group.buttons = group.buttons.filter((button: any) => {
                        // Nếu button có id khớp, loại bỏ nó
                        if (idsToRemove.includes(button.id)) {
                            return false;
                        }
                        // Nếu button có nested buttons, gọi đệ quy để xử lý
                        if (button.buttons && Array.isArray(button.buttons)) {
                            button.buttons = button.buttons.filter((subButton: any) => !idsToRemove.includes(subButton.id));
                        }
                        return true;
                    });
                }

                // Kiểm tra nếu chính group.id nằm trong idsToRemove
                return !idsToRemove.includes(group.id);
            })
            .filter(group => group); // Loại bỏ các nhóm bị xóa hoàn toàn
    };

    // Hàm tạo button với các thuộc tính đúng
    createButtonElement = (button: any) => {
        const buttonElement = document.createElement('div');
        buttonElement.id = button.id;
        buttonElement.className = button.className || '';

        // Nếu không hiển thị, ẩn thẻ button
        if (!button.show) {
            buttonElement.style.display = 'none';
        }

        // Thêm biểu tượng vào button (nếu có)
        if (button.icon) {
            buttonElement.innerHTML = button.icon;
        }

        // Thêm tooltip vào button (nếu có)
        if (button.tooltip !== undefined) {
            buttonElement.setAttribute('data-tooltip', button.tooltip);
            // Gắn sự kiện để hiển thị và ẩn tooltip
            buttonElement.addEventListener('mouseenter', (event) => this.handleMouseEnter(event, 1000));
            buttonElement.addEventListener('mouseleave', this.handleMouseLeave);
        }

        // Đặt sự kiện click (nếu có)
        if (typeof button.onClick === 'function') {
            buttonElement.addEventListener('click', button.onClick);
        }

        // Nếu button có các button con
        if (button.buttons && Array.isArray(button.buttons) && button.buttons.length > 0) {
            // Duyệt qua các button con và đệ quy để tạo ra các button con
            button.buttons.forEach((subButton: any) => {
                const subButtonElement = this.createButtonElement(subButton);
                if (subButtonElement) {
                    buttonElement.appendChild(subButtonElement); // Gắn trực tiếp vào thẻ cha
                }
            });
        }



        return buttonElement;



    };

    handlePositionToolbar = (width: number, height: number, containerId: HTMLElement) => {
        // Height
        const toolbarGr = containerId.querySelector(`.custom-toolbar-dpu`) as HTMLElement | null;
        const zoomIn = containerId.querySelector(`.zoom-earth.in`) as HTMLElement | null;
        const zoomOut = containerId.querySelector(`.zoom-earth.out`) as HTMLElement | null;
        const cesiumCompass = containerId.querySelector(`.cesium-compass`) as HTMLElement | null;

        if (height <= 400) {
            toolbarGr?.style.removeProperty('top');
            toolbarGr?.classList.add('resp-h400');


        } else if (height > 400 && height <= 555) {

            toolbarGr?.style.setProperty('top', '50px');
            zoomIn?.classList.add('resp-zoom-earth-in-h550');
            zoomOut?.classList.add('resp-zoom-earth-out-h550');
            toolbarGr?.classList.remove('resp-h400');
            if (cesiumCompass) {
                cesiumCompass.style.left = '5px';
                cesiumCompass.style.right = 'unset';
                cesiumCompass.style.top = '130px';
            }
        } else if (height > 555) {
            // Xóa các style khi height > 555
            toolbarGr?.style.removeProperty('top');
            zoomIn?.classList.remove('resp-zoom-earth-in-h550');
            zoomOut?.classList.remove('resp-zoom-earth-out-h550');
            toolbarGr?.classList.remove('resp-h400');

            cesiumCompass?.style.removeProperty('left');
            cesiumCompass?.style.removeProperty('right');
            cesiumCompass?.style.removeProperty('top');
        }

        // Width
        const footerContainer = containerId?.querySelectorAll(`.footer-info-content`);

        if (this._mapWeather!.selectedMap.name !== 'None') {
            if (width <= 650) {
                // Ẩn tất cả trừ phần tử đầu tiên
                footerContainer?.forEach((element, index) => {
                    const htmlElement = element as HTMLElement; // Ép kiểu
                    if (index !== 0) {
                        htmlElement.style.display = 'none';
                    }
                });
            } else if (width > 650) {
                footerContainer?.forEach((element, index) => {
                    const htmlElement = element as HTMLElement; // Ép kiểu
                    if (index !== 0) {
                        htmlElement.style.display = 'unset';
                    }
                });
            }
        }
    };


    //#region HTML event

    /**
     * Hàm acive button theo ID 
     * @param {string} idTarget ID của thẻ
     * @param {boolean} active hành động
     */
    public _activeBtn = (idTarget: string, active: boolean) => {
        const btnSelect = document.getElementById(idTarget)
        if (active) {
            btnSelect!.classList.add('active')
        } else {
            btnSelect!.classList.remove('active')
        }
    }

    /**
     * Hàm ẩn hiện element theo ID
     * @param {string} idElement ID của thẻ 
     * @param {string} showElement true = show, hide = false
     */

    public _showHideElementByID = (idElement: string, showElement: boolean) => {
        const element = document.getElementById(idElement);
        if (element) {
            if (showElement) {
                element!.style.removeProperty("display");
            } else {
                element!.style.display = "none";
            }
        }
    }

    /**
     * Hiển thị hoặc ẩn các phần tử HTML dựa trên danh sách ID.
     *
     * @param idElements - Mảng chứa các ID của các phần tử HTML cần hiển thị hoặc ẩn.
     * @param showElements - Nếu là true, các phần tử sẽ được hiển thị; nếu là false, các phần tử sẽ bị ẩn.
     */
    public _showHideElementsByID = (idElements: string[], showElements: boolean) => {
        idElements.forEach(id => {
            this._showHideElementByID(id, showElements);
        });
    }
    /**
     * Hàm active button trong group
     * @param {string[]} listBtn Danh sách ID các button
     * @param {string} idActive ID button active
     */

    public _activeBtnInGroup = (listBtn: string[], idActive: string) => {
        listBtn.forEach(id => {
            this._activeBtn(id, false);
        })
        if (listBtn.includes(idActive)) {
            this._activeBtn(idActive, true)
        }
    }

    public _unActiveBtnInGroup = (listBtn: string[]) => {
        listBtn.forEach(id => {
            this._activeBtn(id, false);
        })
    }

    public deactivateOtherTools = (activeTool: MapToolType) => {
        const containerId = this._containerIdView;

        if (activeTool !== MapToolType.MEASURE && activeTool !== MapToolType.CLIPPING_PLANE) {
            const doneBtn = document.getElementById(this._doneDimId);
            if (doneBtn && doneBtn.style.display !== 'none') {
                this.ToolBarActionDim(this._doneDimId, containerId);
            }
        }
        if (activeTool !== MapToolType.POINT) {
            const doneBtn = document.getElementById(this._donePointId);
            if (doneBtn && doneBtn.style.display !== 'none') {
                this.ToolBarActionPoint(this._donePointId, containerId);
            }
        }
        if (activeTool !== MapToolType.LABEL_POINT) {
            if (this._isShowModalLabelProperties) {
                this.isShowModalLabelProperties = false;
            }
        }
        if (activeTool !== MapToolType.CLIPPING_PLANE && activeTool !== MapToolType.MEASURE) {
            if (this._activeBtnClippingPlane) {
                this.ToolBarActionClippingPlane(this._clippingPlaneDoneId, containerId);
            }
        }
        if (activeTool !== MapToolType.FLY_CAMERA) {
            const doneBtn = document.getElementById(this._doneFlyId);
            if (doneBtn && doneBtn.style.display !== 'none') {
                this.ToolBarActionFlyCamera(this._doneFlyId);
            }
        }

        if (activeTool !== MapToolType.ISSUE_POINT) {
            if (this.isShowModalIssuePoint) {
                this.isShowModalIssuePoint = false;
            }
        }
    }

    //#region TreeView
    private _activeBtnModel = false;
    mapModel = (idElement: string) => {
        this._activeBtnModel = !this._activeBtnModel
        if (!this._activeBtnModel) {
            this._activeBtn(idElement, false)
            // treeFolderModel!.showHideModalTreeFolder(false)
            this._treeTileModel!.showHideModalTreeFolder(false)
        } else {
            this._activeBtn(idElement, true)
            // treeFolderModel!.showHideModalTreeFolder(true)
            this._treeTileModel!.showHideModalTreeFolder(true)

        }

        // treeFolderModel!.setClosedCallback((status: boolean) => {
        //     if (!status) {
        //         activeBtn(idElement, false)
        //         activeBtnModel = false;
        //     }
        // })
        this._treeTileModel!.setClosedCallback((status: boolean) => {
            if (!status) {
                this._activeBtn(idElement, false)
                this._activeBtnModel = false;
            }
        })
    }

    //#region TreeLayerModel
    private _activeBtnLayerModel = false;
    layerModel = (idElement: string) => {
        this._activeBtnLayerModel = !this._activeBtnLayerModel
        if (!this._activeBtnLayerModel) {
            this._activeBtn(idElement, false)
            this._layerModel!.showHideModalTreeLayerModel(false)
        } else {
            this._activeBtn(idElement, true)
            this._layerModel!.showHideModalTreeLayerModel(true)

        }

        this._layerModel!.setClosedCallback((status: boolean) => {
            if (!status) {
                this._activeBtn(idElement, false)
                this._activeBtnLayerModel = false;
            }
        })
    }




    //#region Map Weather
    private _isShowModalMapWeather = false;
    ToolBarActionMapWeather = (idElement: string) => {
        this._isShowModalMapWeather = !this._isShowModalMapWeather
        if (!this._isShowModalMapWeather) {
            this._activeBtn(idElement, false)
            this._mapWeather!.showHideModalMapWeather(false)
        } else {
            this._activeBtn(idElement, true)
            this._mapWeather!.showHideModalMapWeather(true)

        }
        this._mapWeather!.setClosedCallback((status: boolean, typeMap: string) => {
            if (!status) {
                this._activeBtn(idElement, false)
                this._isShowModalMapWeather = false;
            }
            if (typeMap === 'None') {
                // contextMenu!.opacityClick = 1.0
            } else {
                // contextMenu!.opacityClick = 1.0

            }
        })

    }

    //#region  Measure
    ToolBarActionDim = (idElement: string, containerId: string) => {
        this._measureHandler.handle(idElement, containerId);
    }

    //#region Point
    ToolBarActionPoint = (idElement: string, containerId: string) => {
        this._pointHandler.handle(idElement, containerId);
    }


    //#region Data Element
    private _isShowModalDataElement = false;

    get isShowModalDataElement(): boolean {
        return this._isShowModalDataElement;
    }

    set isShowModalDataElement(value: boolean) {
        const idElement = `data-element-${this._containerIdView}`
        if (this._isShowModalDataElement !== value) {
            this._isShowModalDataElement = value;
            if (value) {
                this._activeBtn(idElement, true);
                this._dataProperties!.showHideModalDataElement(true);
            } else {
                this._activeBtn(idElement, false);
                this._dataProperties!.showHideModalDataElement(false);
                // this._showHideElementByID(`label-properties-${this._containerIdView}`, true);
            }

            this.resetDialog(idElement);

        }
    }


    ToolBarActionDataElement = (idElement: string) => {

        // Gọi setter để thay đổi trạng thái modal
        this.isShowModalDataElement = !this.isShowModalDataElement;

        this._dataProperties!.setClosedCallback((status: boolean) => {
            if (!status) {
                this.isShowModalDataElement = false; // Đảm bảo setter tự động xử lý khi đóng modal
            }
        });
    }


    //#region label Point
    private _isShowModalLabelProperties = false;

    get isShowModalLabelProperties(): boolean {
        return this._isShowModalLabelProperties;
    }

    set isShowModalLabelProperties(value: boolean) {
        const idElement = `label-properties-${this._containerIdView}`
        if (this._isShowModalLabelProperties !== value) {
            this._isShowModalLabelProperties = value;
            if (value) {
                this.deactivateOtherTools(MapToolType.LABEL_POINT);
                this._activeBtn(idElement, true);
                this._labelPoint!.showHideModalLabelProperties(true);

                this._contextMenu?.destroyContextMenu();

                // Tắt bật lại Data element
                this._showHideElementByID(`data-element-${this._containerIdView}`, false);
                this._showHideElementByID(`group-data-${this._containerIdView}`, false);
                this._showHideElementByID(`dim-group-${this._containerIdView}`, false);
                this._showHideElementByID(`point-group-${this._containerIdView}`, false);
                this._showHideElementByID(`group-camera-${this._containerIdView}`, false);
                this._showHideElementByID(`group-note-${this._containerIdView}`, false);
            } else {
                this._activeBtn(idElement, false);
                this._labelPoint!.showHideModalLabelProperties(false);
                this._contextMenu?.createContextMenu();

                // Tắt bật lại Data element
                this._showHideElementByID(`data-element-${this._containerIdView}`, true);
                this._showHideElementByID(`group-data-${this._containerIdView}`, true);
                this._showHideElementByID(`dim-group-${this._containerIdView}`, true);
                this._showHideElementByID(`point-group-${this._containerIdView}`, true);
                this._showHideElementByID(`group-camera-${this._containerIdView}`, true);
                this._showHideElementByID(`group-note-${this._containerIdView}`, true);
            }
            this.resetDialog(idElement);
        }
    }



    ToolBarActionLabelPropeties = (idElement: string) => {

        // Gọi setter để thay đổi trạng thái modal
        this.isShowModalLabelProperties = !this.isShowModalLabelProperties;

        this._labelPoint!.setClosedCallback((status: boolean) => {
            if (!status) {
                this.isShowModalLabelProperties = false; // Đảm bảo setter tự động xử lý khi đóng modal
            }
        });
    }

    //#region Clipping plane
    ToolBarActionClippingPlane = (idElement: string, containerId: string) => {
        this._clippingPlaneHandler.handle(idElement, containerId);
    }

    //#region Fly
    ToolBarActionFlyCamera = (idElement: string) => {
        this._flyCameraHandler.handle(idElement);
    }


    //#region IssuePoint
    get isShowModalIssuePoint(): boolean {
        return this._isShowModalIssuePoint;
    }

    set isShowModalIssuePoint(value: boolean) {
        const idElement = `issue-point-${this._containerIdView}`
        // Nếu giá trị thay đổi, thực hiện các thao tác liên quan
        if (this._isShowModalIssuePoint !== value) {
            this._isShowModalIssuePoint = value;
            if (value) {
                this.issuePoint!.showHideModalIssuePoint(true);
                this._activeBtn(idElement, true);

            } else {
                this.issuePoint!.showHideModalIssuePoint(false);
                this._activeBtn(idElement, false);

            }
            this.issuePoint?.triggerChange({
                action: "Button Active",
                status: value
            })
            this.resetDialog(idElement)

        }
    }
    ToolBarActionIssuePoint = (idElement: string) => {
        this._issuePointHandler.handle(idElement);
    }


    //#region Reset Dialog
    resetDialog = (idElement: string) => {

        switch (idElement) {
            case `label-properties-${this._containerIdView}`:
                //Tắt Data element nếu bật
                if (this._isShowModalDataElement) {
                    this._showHideElementByID(`data-element-${this._containerIdView}`, false)
                    this._showHideElementByID(`group-data-${this._containerIdView}`, false)
                    this.isShowModalDataElement = false;
                }
                break;
            case `data-element-${this._containerIdView}`:
                //Tắt Label Point element nếu bật
                if (this._isShowModalDataElement) {
                    this._showHideElementByID(`group-distance-${this._containerIdView}`, false)
                    this._showHideElementByID(`group-camera-${this._containerIdView}`, false)
                    this._showHideElementByID(`group-note-${this._containerIdView}`, false)
                } else {
                    this._showHideElementByID(`group-distance-${this._containerIdView}`, true)
                    this._showHideElementByID(`group-camera-${this._containerIdView}`, true)
                    this._showHideElementByID(`group-note-${this._containerIdView}`, true)
                }
                break;
            case `map-weather-${this._containerIdView}`:
                if (this._isShowModalMapWeather) {
                    this._isShowModalMapWeather = false;
                    this._activeBtn(`map-weather-${this._containerIdView}`, false)
                    this._mapWeather!.showHideModalMapWeather(false)
                }
                break;

            case `clipping-plane-${this._containerIdView}`:
                if (this._activeBtnClippingPlane) {
                    this.ToolBarActionClippingPlane(`clipping-plane-done-${this._containerIdView}`, this._containerIdView);
                }
                break;
            case `issue-point-${this._containerIdView}`:
                if (this._isShowModalIssuePoint) {
                    this._showHideElementByID(`group-distance-${this._containerIdView}`, false)
                    this._showHideElementByID(`group-data-${this._containerIdView}`, false)
                    this._showHideElementByID(`group-camera-${this._containerIdView}`, false)
                } else {
                    this._showHideElementByID(`group-distance-${this._containerIdView}`, true)
                    this._showHideElementByID(`group-data-${this._containerIdView}`, true)
                    this._showHideElementByID(`group-camera-${this._containerIdView}`, true)
                }
                break;
            case `fly-camera-${this._containerIdView}`:
                if (this._activeBtnModel) {
                    this.mapModel(`map-model-${this._containerIdView}`);
                }
                if (this._activeBtnLayerModel) {
                    this.layerModel(`layer-element-${this._containerIdView}`);
                }
                if (this._isShowModalMapWeather) {
                    this._mapWeather?.showHideModalMapWeather(false)
                    this._isShowModalMapWeather = false
                    this._activeBtn(`map-weather-${this._containerIdView}`, false)
                }
                if (this._activeBtnClippingPlane) {
                    this.ToolBarActionClippingPlane(`clipping-plane-done-${this._containerIdView}`, this._containerIdView);
                }
                this._showHideElementByID(`group-model-${this._containerIdView}`, false)
                this._showHideElementByID(`group-location-${this._containerIdView}`, false)
                this._showHideElementByID(`group-distance-${this._containerIdView}`, false)
                this._showHideElementByID(`group-data-${this._containerIdView}`, false)
                this._showHideElementByID(`group-note-${this._containerIdView}`, false)
                break;
            default:
                break;
        }
    }

    // ████████  ██████   ██████  ██      ████████ ██ ██████  
    //    ██    ██    ██ ██    ██ ██         ██    ██ ██   ██ 
    //    ██    ██    ██ ██    ██ ██         ██    ██ ██████  
    //    ██    ██    ██ ██    ██ ██         ██    ██ ██      
    //    ██     ██████   ██████  ███████    ██    ██ ██      

    //#region ToolTip
    private _tooltip: HTMLDivElement | null = null;
    private _currentTooltipTarget: HTMLElement | null = null; // Phần tử hiện đang hiển thị tooltip
    private _timeoutId: number | null = null; // ID của timeout
    private _IdGenneralTooltip = createUUID()

    // Hàm xử lý khi di chuột vào phần tử có `data-tooltip`
    handleMouseEnter = (event: MouseEvent, delay: number = 2000) => {
        let target = event.target as HTMLElement;
        // Duyệt tìm thẻ cha nếu thẻ con không chứa `data-tooltip`
        while (target && !target.hasAttribute('data-tooltip')) {
            target = target.parentElement as HTMLElement;
        }

        // Kiểm tra nếu tìm thấy thẻ cha có `data-tooltip` và nó không phải là phần tử hiện tại
        if (target && target !== this._currentTooltipTarget) {
            this._currentTooltipTarget = target;

            if (this._tooltip) {
                this.hideTooltip();
            }
            // Thêm độ trễ 1 giây trước khi hiển thị tooltip
            if (this._timeoutId) {
                clearTimeout(this._timeoutId); // Hủy timeout cũ nếu tồn tại
            }

            // Thêm độ trễ 1 giây trước khi hiển thị tooltip
            this._timeoutId = window.setTimeout(() => {
                this.showTooltip(target);
            }, delay); // Độ trễ 1000ms
        }
    }

    // Hàm xóa tooltip khỏi DOM
    hideTooltip = () => {
        // Tìm tất cả các phần tử có id là 'dynamic-tooltip'
        const tooltips = document.querySelectorAll(`#dynamic-tooltip-${this._IdGenneralTooltip}`);

        // Xóa từng tooltip nếu tồn tại trong DOM
        tooltips.forEach((tooltip) => {
            tooltip.parentNode?.removeChild(tooltip);
        });

        // Đặt lại giá trị của tooltip và các biến liên quan
        this._tooltip = null;
        this._currentTooltipTarget = null; // Xóa tham chiếu đến phần tử hiện tại

        if (this._timeoutId) {
            clearTimeout(this._timeoutId); // Hủy thời gian chờ nếu có
            this._timeoutId = null;
        }
    }


    // Hàm tạo tooltip với nội dung và vị trí
    showTooltip = (target: HTMLElement) => {
        const tooltipText = target.getAttribute('data-tooltip');

        if (!tooltipText) return;
        const containerId = document.querySelector(`#${this._containerIdView}`) as HTMLElement
        const containerView = containerId.querySelector(`.cesium-widget`) as HTMLElement
        const canvasView = containerView.querySelector(`canvas`) as HTMLElement
        const toolBar = containerId.querySelector(`.custom-toolbar-dpu`) as HTMLElement
        // Tạo tooltip mới
        this._tooltip = document.createElement('div');
        this._tooltip.className = 'dynamic-tooltip dynamic-tooltip-arrow-right';
        this._tooltip.id = `dynamic-tooltip-${this._IdGenneralTooltip}`;
        this._tooltip.innerText = tooltipText;

        // Thêm tooltip vào `body`
        containerId!.appendChild(this._tooltip);
        const topOffset = toolBar.offsetTop
        // Lấy vị trí và kích thước của phần tử mục tiêu
        const rect = target.getBoundingClientRect();
        const rectCanvas = canvasView.getBoundingClientRect();

        const tooltipWidth = this._tooltip.offsetWidth;

        if (containerId.offsetHeight >= 400) {
            // Đặt tooltip bên trái của phần tử với khoảng cách 5px và căn giữa theo chiều dọc
            this._tooltip.style.left = `${rect.left - rectCanvas.left - tooltipWidth - 10}px`;
            this._tooltip.style.top = `${topOffset + target.offsetTop + rect.height / 2 - this._tooltip.offsetHeight / 2}px`;
        } else if (containerId.offsetHeight < 400) {
            this._tooltip.classList.remove('dynamic-tooltip-arrow-right')
            this._tooltip.classList.add('tooltip-arrow-bottom')
            // Đặt tooltip bên trái của phần tử với khoảng cách 5px và căn giữa theo chiều dọc
            this._tooltip.style.left = `${rect.left - rectCanvas.left - this._tooltip.offsetWidth / 2 + rect.width / 2}px`;
            this._tooltip.style.top = `${topOffset + target.offsetTop - rect.height - 10}px`;
        }


    }
    // Hàm xử lý khi di chuột ra khỏi phần tử có `data-tooltip`
    handleMouseLeave = (event: any) => {
        const target = event.target;

        if (target && target.hasAttribute('data-tooltip') || this._tooltip) {
            if (this._timeoutId) {
                clearTimeout(this._timeoutId); // Hủy timeout nếu rời chuột trước khi tooltip hiển thị
                this._timeoutId = null;
            }
            this.hideTooltip(); // Gọi hàm để xóa tooltip ngay lập tức khi rời chuột
        }
    };

}